<template>
  <v-layout row wrap class="px-5">
    <v-flex xs12 mb-3>
      <h3 class="black--text">Uploaded File</h3>
    </v-flex>
    <v-flex xs12 mb-3 v-if="supportDoc.length > 0">
      <v-simple-table class="spending-table nav-table">
        <thead>
          <tr>
            <th width="70%">File Name</th>
            <th colspan="2">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in supportDoc" :key="item.id">
            <td width="70%">{{ item.file }}</td>
            <td class="text-center">
              <v-btn
                :loading="loading3"
                small
                color="thirdblue"
                class="ma-2 white--text text-capitalize"
                @click="downloadFile(item)"
              >
                Download
                <v-icon right dark>mdi-cloud-download</v-icon>
              </v-btn>
            </td>
            <td v-if="isEdit" class="text-center">
              <v-btn
                :loading="loading4"
                :disabled="loading4"
                small
                color="#bd1e19"
                class="ma-2 white--text text-capitalize"
                @click="fileRemoved(item.name)"
              >
                Remove
                <v-icon right dark>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-flex>
    <v-flex xs-12 mb-3 v-else class="greydark">
      <p class="text-center pt-3">No data displayed</p>
    </v-flex>
    <v-flex xs12>
      <hr class="hr-line" />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    supportDoc: {
      type: Array,
      required: true
    },
    downloadFile: {
      type: Function,
      required: true
    },
    fileRemoved: {
      type: Function,
      required: true
    },
    loading3: {
      type: Boolean,
      required: true
    },
    loading4: {
      type: Boolean,
      required: true
    },
    isEdit: {
      type: Boolean
    }
  }
};
</script>
